import http from '@/assets/js/common/http-common';

class DashBoardDataService {

    nQuestions() {
        return http.post('painel/nQuestions', null);
    }

    nStudents() {
        return http.post('painel/nStudents', null);
    }
    
    nTests() {
        return http.post('painel/nTests', null);
    }

    nTestsbyMonth(data) {
        return http.post('painel/nTestsbyMonth', data);
    }

}

export default new DashBoardDataService();
